/**
 * Recommender plugin
 * @module
 */

/**
 * PluginManager registration method
 * @param {PluginManager} PluginManager
 */
module.exports = function(PluginManager:PluginManagerClass) {
  PluginManager.registerApiModule('recommender', require('./api'));
};
